import styled from "@emotion/styled";
import Switch from "@mui/material/Switch";
import { palettes } from "../themes/palletes";

export const AppSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,

  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    width: "37px",
    height: "18px",
    transition: "background-color 0.3s ease-in-out",
    backgroundColor: "#C3CEDD",
    opacity: "100%",
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 12,
    height: 12,
    margin: 2,
    backgroundColor: "white",
    transition: "transform 0.3s ease-in-out, background-color 0.3s ease-in-out",
  },

  "& .Mui-checked + .MuiSwitch-track": {
    backgroundColor: "#FF5F47 !important",
    opacity: "1 !important",
  },

  "& .Mui-disabled + .MuiSwitch-track": {
    backgroundColor: palettes.$disabled,
    opacity: "100%",
  },
}));
